export default "__VITE_ASSET__ByJ0r7fy__"